const shortUUiD = require("short-uuid");

export const doesSameFieldExist = (name, fields, parentID, fieldId) => {

    let status = true;

    if (fieldId === undefined) {
        status = fields.find(field => {
            return field.parent[0].id == parentID && field.name == name;
        });
    } else {
        status = fields.find(field => {
            return field.parent[0].id == parentID && field.name == name && field.id != fieldId;
        });
    }



    return status == null ? true : false;
}


export const createDefaultNestedFieldsForChartBarLine = (parent) => {

    const children = [
        {
            "name": "X",
            "attributes": {
                "type": "UINT32",
                "axis": "x"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "Y",
            "attributes": {
                "type": "UINT32",
                "axis": "y"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        }
    ];

    return children;
}

export const createDefaultNestedFieldsForRatioBarChart = (parent) => {

    const children = [
        {
            "name": "X",
            "attributes": {
                "type": "string",
                "axis": "x"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "Y",
            "attributes": {
                "type": "UINT32",
                "axis": "y"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        }
    ];

    return children;
}

export const createDefaultNestedFieldsForStackBarChart = (parent) => {

    const children = [
        {
            "name": "X",
            "attributes": {
                "type": "UINT32",
                "axis": "x"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "Y1",
            "attributes": {
                "type": "UINT32",
                "axis": "y"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "Y2",
            "attributes": {
                "type": "UINT32",
                "axis": "y"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        }
    ];

    return children;
}

export const createDefaultNestedFieldsForChartPie = (parent) => {

    const children = [
        {
            "name": "X",
            "attributes": {
                "type": "string",
                "axis": "x"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        }, {
            "name": "Y",
            "attributes": {
                "type": "UINT32",
                "axis": "y"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        }



    ];

    return children;
}

export const createDefaultNestedFieldsForChartGeomap = (parent) => {

    const children = [
        {
            "name": "coordinates",
            "attributes": {
                "type": "table",

            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ],
            "children": [{
                "name": "lat",
                "attributes": {
                    "type": "double",
                },
                "type": 12,
                "parent": [
                    {
                        "type": "field"
                    }
                ]

            },
            {
                "name": "lng",
                "attributes": {
                    "type": "double",
                },
                "type": 12,
                "parent": [
                    {
                        "type": "field"
                    }
                ]
            },
            {
                "name": "type",
                "attributes": {
                    "type": "OCTETSTRING",
                },
                "type": 12,
                "parent": [
                    {
                        "type": "field"
                    }
                ]
            },
            {
                "name": "icon",
                "attributes": {
                    "type": "string",
                },
                "type": 12,
                "parent": [
                    {
                        "type": "field"
                    }
                ]
            },
            {
                "name": "label",
                "attributes": {
                    "type": "string",
                },
                "type": 12,
                "parent": [
                    {
                        "type": "field"
                    }
                ]
            }
            ]
        },
        {
            "name": "polygons",
            "attributes": {
                "type": "table",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ],
            "children": [{
                "name": "lat",
                "attributes": {
                    "type": "double",
                },
                "type": 12,
                "parent": [
                    {
                        "type": "field"
                    }
                ]
            },
            {
                "name": "lng",
                "attributes": {
                    "type": "double",
                },
                "type": 12,
                "parent": [
                    {
                        "type": "field"
                    }
                ]
            }

            ]
        }

    ]

    return children;
}


export const formatDateTime = (date, format = 'yyyy-MM-dd') => {
    const dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const mm = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
    const yyyy = date.getFullYear();
    const time = date.toTimeString().split(' ')[0];
    const formattedDate = yyyy + '-' + mm + '-' + dd + ' ' + time;
    return formattedDate;
}

export const createDefaultNestedFieldsForVideo = (parent) => {

    const children = [{
        "name": "url",
        "attributes": {
            "type": "OCTETSTRING",
        },
        "type": 12,
        "parent": [
            {
                "type": "field"
            }
        ]
    }];

    return children;

}

export const createDefaultNestedFieldsForImage = (parent) => {

    const children = [{
        "name": "url",
        "attributes": {
            "type": "OCTETSTRING",
        },
        "type": 12,
        "parent": [
            {
                "type": "field"
            }
        ]
    }];

    return children;

}

export const createNestedFieldsForControls = (parent) => {
    const children = [{
        "name": "value",
        "attributes": {
            "type": "UINT32",
        },
        "type": 12,
        "parent": [
            {
                "type": "field"
            }
        ]
    }];

    return children;
}

export const createDefaultNestedFieldsForURLExternal = (parent) => {

    const children = [
        {
            "name": "value",
            "attributes": {
                "type": "string",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "url",
            "attributes": {
                "type": "string",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        }

    ]

    return children;
}




export const createDefaultNestedFieldsForURLClusterlet = (parent) => {

    const children = [{
        "name": "value",
        "attributes": {
            "type": "string",
        },
        "type": 12,
        "parent": [
            {
                "type": "field"
            }
        ]
    },
    {
        "name": "name",
        "attributes": {
            "type": "string",
        },
        "type": 12,
        "parent": [
            {
                "type": "field"
            }
        ]
    },
    {
        "name": "clusterlet_type",
        "attributes": {
            "type": "string",
        },
        "type": 12,
        "parent": [
            {
                "type": "field"
            }
        ]
    }]

    return children;
}




export const createDefaultNestedFieldsForURLView = (parent) => {

    const children = [
        {
            "name": "value",
            "attributes": {
                "type": "string",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "instance",
            "attributes": {
                "type": "string",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "name",
            "attributes": {
                "type": "string",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        }
    ]

    return children;
}

export const createDefaultNestedFieldsForModel3D = (parent) => {

    const children = [{
        "name": "url",
        "attributes": {
            "type": "string",
        },
        "type": 12,
        "parent": [
            {
                "type": "field"
            }
        ]
    }]

    return children;
}

export const formatTemplateFileds = (msgId, fieldsChildren = []) => {

    let formatedFileds = [];
    fieldsChildren.forEach(field => {
        let fldObj = {
            name: field.name,
            attributes: field.args,
            id: shortUUiD.generate(),
            type: 12,
            parent: [{
                id: msgId,
                type: 'field'
            }]
        }

        formatedFileds.push(fldObj)
    })

    return formatedFileds;

}

export const createDefaultNestedFieldsForScene3D = parent => {

    const children = [
        {
            "name": "topleftlat",
            "attributes": {
                "type": "double",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "topleftlng",
            "attributes": {
                "type": "double",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "bottomrightlat",
            "attributes": {
                "type": "double",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "bottomrightlng",
            "attributes": {
                "type": "double",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "terrain",
            "attributes": {
                "type": "struct",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ],
            "children": [{
                "name": "texture",
                "attributes": {
                    "type": "string",
                },
                "type": 12,
                "parent": [
                    {
                        "type": "field"
                    }
                ]
            },
            {
                "name": "heightmap",
                "attributes": {
                    "type": "string",
                },
                "type": 12,
                "parent": [
                    {
                        "type": "field"
                    }
                ]
            }
            ]
        },
        {
            "name": "objects",
            "attributes": {
                "type": "table",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ],
            "children": [
                {
                    "name": "lat",
                    "attributes": {
                        "type": "double",
                    },
                    "type": 12,
                    "parent": [
                        {
                            "type": "field"
                        }
                    ]
                },
                {
                    "name": "lng",
                    "attributes": {
                        "type": "double",
                    },
                    "type": 12,
                    "parent": [
                        {
                            "type": "field"
                        }
                    ]
                },
                {
                    "name": "alt",
                    "attributes": {
                        "type": "double",
                    },
                    "type": 12,
                    "parent": [
                        {
                            "type": "field"
                        }
                    ]
                },
                {
                    "name": "type",
                    "attributes": {
                        "type": "string",
                    },
                    "type": 12,
                    "parent": [
                        {
                            "type": "field"
                        }
                    ]
                },
                {
                    "name": "instance",
                    "attributes": {
                        "type": "url-clusterlet",
                    },
                    "type": 12,
                    "parent": [
                        {
                            "type": "field"
                        }
                    ],
                    "children": [
                        {
                            "name": "value",
                            "attributes": {
                                "type": "string",
                            },
                            "type": 12,
                            "parent": [
                                {
                                    "type": "field"
                                }
                            ]
                        },
                        {
                            "name": "name",
                            "attributes": {
                                "type": "string",
                            },
                            "type": 12,
                            "parent": [
                                {
                                    "type": "field"
                                }
                            ]
                        },
                        {
                            "name": "clusterlet_type",
                            "attributes": {
                                "type": "string",
                            },
                            "type": 12,
                            "parent": [
                                {
                                    "type": "field"
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "label",
                    "attributes": {
                        "type": "string",
                    },
                    "type": 12,
                    "parent": [
                        {
                            "type": "field"
                        }
                    ]
                }
            ]
        },
        {
            "name": "label",
            "attributes": {
                "type": "string",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        }
    ]

    return children;

}

export const createDefaultNestedFieldsForCompass = (parent) => {


    const children = [
        {
            "name": "direction",
            "attributes": {
                "type": "UINT32",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "content",
            "attributes": {
                "type": "string",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        }
    ]

    return children;
}

export const createDefaultNestedFieldsForChartPieRadial = (parent) => {

    const children = [
        {
            "name": "X",
            "attributes": {
                "type": "string",
                "axis": "x",
                "desc": "X axis",
                "unit": "X unit"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "Y",
            "attributes": {
                "type": "UINT32",
                "axis": "y",
                "desc": "Y axis",
                "unit": "Y unit"
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        },
        {
            "name": "maxval",
            "attributes": {
                "type": "UINT32",
                "desc": "Maximum value",
            },
            "type": 12,
            "parent": [
                {
                    "type": "field"
                }
            ]
        }
    ];

    return children;

}

export const createDefaultNestedFieldsForHeatmap = (parent) => {
    return [
        {
            name: 'X',
            attributes: {
                type: 'string',
                axis: 'x',
                desc: '',
                unit: ''
            },
            type: 12,
            parent: [
                {
                    type: 'field'
                }
            ]
        },
        {
            name: 'Y',
            attributes: {
                type: 'string',
                axis: 'y',
                desc: '',
                unit: ''
            },
            type: 12,
            parent: [
                {
                    type: 'field'
                }
            ]
        },
        {
            name: 'data',
            attributes: {
                type: 'UINT32',
                desc: '',
                unit: ''
            },
            type: 12,
            parent: [
                {
                    type: 'field'
                }
            ]
        }
    ]
}

export const createDefaultNesterFieldsForGauge = (parent) => {
    return [
        {
            name: 'value',
            attributes: {
                type: 'double',
                desc: '',
            },
            type: 12,
            parent: [
                {
                    type: 'field'
                }
            ]
        },
        {
            name: 'ranges',
            attributes: {
                type: 'table',
                desc: ''
            },
            children: [
                {
                    name: 'low',
                    attributes: {
                        type: 'double',
                        desc: '',
                        unit: ''
                    },
                    type: 12,
                    parent: [
                        {
                            type: 'field'
                        }
                    ]
                },
                {
                    name: 'high',
                    attributes: {
                        type: 'double',
                        desc: '',
                        unit: ''
                    },
                    type: 12,
                    parent: [
                        {
                            type: 'field'
                        }
                    ]
                },
                {
                    name: 'color',
                    attributes: {
                        type: 'string',
                        desc: '',
                    },
                    type: 12,
                    parent: [
                        {
                            type: 'field'
                        }
                    ]
                }
            ],
            type: 12,
            parent: [
                {
                    type: 'field'
                }
            ]
        },
    ]
}

export const createDefaultNestedFieldsForRangePlot = (parent) => {
    return [
        {
            name: 'X',
            attributes: {
                type: 'string',
                axis: 'x',
                desc: '',
                unit: ''
            },
            type: 12,
            parent: [
                {
                    type: 'field'
                }
            ]
        },
        {
            name: 'Y',
            attributes: {
                type: 'struct',
                axis: 'y',
                desc: '',
                unit: ''
            },
            children: [
                {
                    name: 'low',
                    attributes: {
                        type: 'uint32',
                        desc: '',
                        unit: ''
                    },
                    type: 12,
                    parent: [
                        {
                            type: 'field'
                        }
                    ]
                },
                {
                    name: 'high',
                    attributes: {
                        type: 'uint32',
                        desc: '',
                        unit: ''
                    },
                    type: 12,
                    parent: [
                        {
                            type: 'field'
                        }
                    ]
                }
            ],
            type: 12,
            parent: [
                {
                    type: 'field'
                }
            ]
        },
    ]
}

export const validateClusterletField = (clusterletId, path, sectionList, fieldList, messageList) => {

    console.log('selectedField---->', clusterletId, path, sectionList, fieldList, messageList)

    let validateParent = false;

    let splitPath = path.split('.');

    console.log('pathlength', splitPath)
    if (splitPath.length == 0) {
        return false
    }

    let fieldName = splitPath[splitPath.length - 1];

    console.log('fdNme--->', fieldName)

    const fieldsMatchingName = fieldList.filter(item => item.name === fieldName);
    console.log('fieldsMatchingName--->', fieldsMatchingName)

    if (fieldsMatchingName.length == 0) {
        return false
    }

    // console.log('fieldsMatchingName---after>', fieldsMatchingName)


    const findRoot = (selectedField) => {

        console.log('selectedfd---->', selectedField)

        const element = fieldList.find(item => item.id === selectedField?.id);
        const parentId = element != undefined ? element.parent[0]?.id : ''
        const parent = fieldList.find(item => item.id === parentId) ? fieldList.find(item => item.id === parentId) : sectionList.find(item => item.id === parentId) ? sectionList.find(item => item.id === parentId) : messageList.find(item => item.id === parentId)

        if (parent === undefined) return false;

        if (parent?.type == 11) {
            if (parent?.parent[0].id == clusterletId && splitPath.includes(parent?.name)) {
                return true;
            }
            else {
                return false;
            }

        }
        else if (parent?.type == 17) {
            return false

        }
        else {
            findRoot(element.parent[0]);
        }
    }

    fieldsMatchingName.forEach(fld => {

        validateParent = findRoot(fld);

    })

    console.log("validate parent---->", validateParent)
    return validateParent;



    // const parentId = element.parent[0].id
    // const parent = fieldList.find(item => item.id === parentId) ? fieldList.find(item => item.id === parentId) : sectionList.find(item => item.id === parentId) ? sectionList.find(item => item.id === parentId) : messageList.find(item => item.id === parentId)
    // // console.log('parent-immdetae-->', parent)
    // if (parent.type === 17) {
    //     root = 'eventType'
    //     setFieldParent(parent)
    // } else if (parent.type === 11) {
    //     // console.log('parent---type 11>', parent)

    //     root = 'property';
    //     setFieldParent(parent)
    //     const clusterlet = clusterletList.find(item => item.id === parent.parent[0].id)
    //     // console.log('parent-clusterlet-->', clusterlet)
    //     // if (selectedField?.parent?.[0]?.type == 'section' && (clusterlet.type === 2 || clusterlet.type === 3)) setParentDT(true);
    //     if (element?.parent?.[0]?.type == 'section' && (clusterlet.type === 2 || clusterlet.type === 3)) setParentDT(true);

    // } else {
    //     findRootElement(element.parent[0]);
    // }
}






// For message as type of fields in event type
export const findMessageTypes = (messages, fields) => {
    const updatedMessages = messages.map(item => {
        item.title = item.name;
        item.value = item._id;
        return item;
    });
    const sortedMessageTyppes = updatedMessages.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    return sortedMessageTyppes;
}



